var map = {
	"./pay-groups.svg": "a7cb",
	"./pay-layout-1.svg": "299f",
	"./pay-layout-2.svg": "6655",
	"./pay-layout-3.svg": "1a55",
	"./pay-room.svg": "591f",
	"./pay-staff-list.svg": "784f",
	"./pay-sublocations.svg": "6952"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2181";